import { addDatapointConfig } from 'owa-analytics-actions';
import { action } from 'satcheljs';

/**
 * action for loading the Time Zone option
 */
const loadTimeZoneOption = action('loadTimeZoneOption', () =>
    addDatapointConfig({ name: 'LoadTimeZoneOption' })
);

export default loadTimeZoneOption;
